import { createContext } from 'react';

const StringsContext = createContext({});

export default StringsContext;
